module.exports = __webpack_public_path__ + "static/media/vitalbook_1.bb223ac2.mp4";